import { render, staticRenderFns } from "./CardCustomization.vue?vue&type=template&id=686bc9ea"
import script from "./CardCustomization.vue?vue&type=script&lang=ts"
export * from "./CardCustomization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports